import React from 'react';

// Styles
import { Container } from './styles';

// Interface
interface Props {
  children: React.ReactNode;
}

export function Span({ children, ...rest }: Props) {
  return <Container {...rest}>{children}</Container>;
}
